import { memo } from "react";
import { useAppSelector } from "../../store/hooks";
import ErrorFallbackComponent from "./ErrorFallbackComponent";
import "./Default.css";
import React from "react";
import {
  getComponentFromStructureMap,
  getComponentIdentityKey,
  withStableComponentId,
} from "./utilities/componentIdentity";
import { shouldRenderWebpageRoot } from "./utilities/webpageRootVisibility";
import { useInlineComponentsMap } from "./context/InlineComponentsMapContext";

declare var defaultComponents: any;

type Props = {
  /** Canonical structure map key (UUID string or numeric id). Legacy prop name: `componentId`. */
  componentKey?: string | number;
  componentId?: string | number;
};

function ContentRenderWebpageComponent({ componentKey, componentId }: Props) {
  const rawKey = componentKey ?? componentId;
  const normalizedKey =
    rawKey === null || rawKey === undefined ? "" : String(rawKey).trim();
  const inlineComponentsMap = useInlineComponentsMap();

  const structureComponent = useAppSelector((state) =>
    getComponentFromStructureMap(
      state.builder.structure.components,
      normalizedKey || rawKey
    )
  );
  const inlineComponent =
    !structureComponent &&
    inlineComponentsMap &&
    typeof inlineComponentsMap === "object"
      ? (inlineComponentsMap[normalizedKey] as any)
      : null;
  const component = structureComponent ?? inlineComponent;

  const editor = useAppSelector((state) => state.builder.editor);

  if (
    !shouldRenderWebpageRoot({
      component,
      editorTemplate: editor?.template,
      knownComponentTypes: defaultComponents,
    })
  ) {
    return <></>;
  }
  const ComponentToRender = defaultComponents[component.type];
  const identityKey = getComponentIdentityKey(component);
  const safeComponent = withStableComponentId(component, normalizedKey || identityKey);

  // @ts-ignore
  return (
    <ErrorFallbackComponent
      key={identityKey + "_errorBoundary_"}
      showHomeButton={true}
    >
      <ComponentToRender {...safeComponent} key={identityKey} />
    </ErrorFallbackComponent>
  );
}

export default memo(ContentRenderWebpageComponent);
